import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
	routes: [

		{
			path: '/',
			name: 'checkinStart',
			meta: {
        requiresAuth: true
			},
			// component: () => import("@/views/SplashScreen")
            component: () => import("@/views/Checkin")
    },
    /*
		{
			path: '/welcome',
			name: 'welcome',
			meta: {
			},
			component: () => import("@/views/Welcome")
    },
		{
			path: '/reservation',
			name: 'reservation',
			meta: {
			},
			component: () => import("@/views/Reservation")
    },
		{
			path: '/mwtest',
			name: 'mwtest',
			meta: {
			},
			component: () => import("@/views/Mwtest")
    },
    */

		{
			path: '/login',
      		name: 'login',
			meta: {
			},
			component: () => import("@/views/Login")
		},
		{
			path: '/bookings',
			name: 'bookings',
			meta: {
        	requiresAuth: true
			},
			component: () => import("@/views/Bookings")
    }
    /*
		{
			path: '/checkin',
				name: 'checkin',
			meta: {
        requiresAuth: true
			},
			component: () => import("@/views/Checkin")
    },

		{
			path: '/checkinlogin',
				name: 'checkinloign',
			meta: {
		},
			component: () => import("@/views/CheckinLogin")
    }
    */


	]
})

/*
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    if (!storageHelper.getItem('user-password')) next({name: 'welcome'})
    else next()
  } else next()
})
/* */

/* */
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    const authUser = JSON.parse(window.localStorage.getItem('authUser'))
    // console.log(authUser);
    if (authUser && authUser.access_token) {
      next()
    } else {
      next({name: 'login'})
    }
  } else {
    next()
  }

})
/* */

export default router
